import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

const HelpIcon = require('assets/resources/Help.svg').default;

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const LABEL_COLORS = ['rgba(6, 137, 17, 1)', 'rgba(6, 137, 17, 1)', 'rgba(188, 85, 0, 1)', 'rgba(34, 34, 34, 1)', 'rgba(34, 34, 34, 1)'];

const RadarChart = (props) => {
  const { data, color = true } = props;

  const { t } = useTranslation();

  const labels = [
    {
      key: 'PB',
      label: t('SCORE_SUMMARY_PB'),
    },
    {
      key: 'PP',
      label: t('SCORE_SUMMARY_PP'),
    },
    {
      key: 'HI',
      label: t('SCORE_SUMMARY_HI'),
    },
    {
      key: 'ES',
      label: t('SCORE_SUMMARY_ES'),
    },
    {
      key: 'CP',
      label: t('SCORE_SUMMARY_CP'),
    },
  ];

  const dataChart = {
    labels: labels.map((label) => label.label),
    datasets: [
      {
        data: labels.map((label) => data[label.key]),
        backgroundColor: 'rgba(8, 105, 233, 0.5)',
        borderColor: 'rgba(8, 105, 233, 1)',
        borderWidth: 1.5,
        pointBackgroundColor: 'rgba(8, 105, 233, 1)',
        pointBorderColor: '#fff',
        pointRadius: 5,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: { display: false },
      datalabels: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    scales: {
      r: {
        min: 0,
        max: Math.max(...Object.values(data)),
        pointLabels: {
          callback: function (label, index) {
            return label;
          },
          font: {
            size: 14,
            weight: 'bold',
          },
          color: function (context) {
            return color ? LABEL_COLORS[context.index] : 'rgba(34, 34, 34, 1)';
          },
        },
        angleLines: {
          display: false,
        },
        grid: {
          display: false,
          circular: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };

  return (
    <div className="w-full h-full">
      <Radar data={dataChart} options={options} />
    </div>
  );
};

export default RadarChart;
